import { toastMessageConfig } from "../../../../../entities/toastMessageConfig";
import { api } from "../../../../api";

export const getRemoveOnClickBtnFunc =
  (componentState, mappingFieldsObj, toastRef, parentComponentState) =>
  async (e) => {
    const [, setComponentStateValue] = componentState;

    setComponentStateValue({ status: "loading" });

    const removeMappingItemResponse = await api.mappingFields.remove(
      mappingFieldsObj.id
    );
    setComponentStateValue({ status: "waiting" });

    const { warning, error } = removeMappingItemResponse;

    if (warning) {
      toastRef.current.show({
        severity: "warn",
        summary: warning.title,
        detail: warning.message,
        life: toastMessageConfig.life,
      });
      return;
    }
    if (error) {
      toastRef.current.show({
        severity: "error",
        summary: error.title,
        detail: error.message,
        sticky: true,
      });
      return;
    }

    toastRef.current.show({
      severity: "success",
      summary: "Powodzenie",
      detail: "Operacja się udała",
      life: toastMessageConfig.life,
    });

    const [, setParentComponentStateValue] = parentComponentState;
    setParentComponentStateValue((prevState) => ({
      ...prevState,
      refreshesNumber: prevState.refreshesNumber + 1,
    }));
  };
